import { createContext } from 'react';

import { LogoutModalContextProps } from './LogoutModalContext.types';

export const LogoutModalContext = createContext<LogoutModalContextProps | undefined>(undefined);
